import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Link,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import { ApplicationActivityBody, ActivityDialogProps } from "../types";
import { FieldChangeItem } from "./FieldChangeItem";

const useStyles = makeStyles((theme) => ({
  changeDetails: {
    padding: 15,
  },
  actions: {
    padding: 15,
  },
}));

export const UpdatedApplicationDialog: React.FC<ActivityDialogProps> = ({
  activity,
  onClose,
}) => {
  const classes = useStyles();

  const body: ApplicationActivityBody = JSON.parse(activity.activityMetaData);

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="updated-dialog"
    >
      <DialogTitle data-test="activity-title">
        {activity.activityTitle}
      </DialogTitle>
      <Divider component="div" />
      <DialogContent>
        {body.changes.map((change, ix) => (
          <FieldChangeItem change={change} key={`${change.field}-${ix}`} />
        ))}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Link
          component="button"
          onClick={onClose}
          data-test="close-change-button"
        >
          Close
        </Link>
      </DialogActions>
    </Dialog>
  );
};
